import { RoomCreate, RoomDetail, RoomUpdate } from "@/types/room";

import { requestData } from "@/api/api-config";

export async function listRooms(): Promise<RoomDetail[] | null> {
  return await requestData<RoomDetail[]>("admin/room/list", "get");
}

export async function createRoom(room: RoomCreate): Promise<RoomDetail | null> {
  return await requestData<RoomDetail>("admin/room/create", "post", {
    json: room,
  });
}

export async function updateRoom(room: RoomUpdate): Promise<RoomDetail | null> {
  return await requestData<RoomDetail>(`admin/room/update/${room.id}`, "put", {
    json: room,
  });
}

export async function deleteRoom(roomId: string): Promise<boolean | null> {
  return await requestData<boolean>(`admin/room/delete/${roomId}`, "delete");
}
